import { FC } from 'react'

import PageHeading from 'components/atoms/PageHeading'
import MainTable from 'components/organisms/tables/MainTable'

import { useTableModel } from 'utils/tableModels/useGroupCourseAssignmentsTableModel'

import { useTranslation } from 'react-i18next'
import { Box, Button, Grid, Tooltip, useTheme } from '@mui/material'
import { useGET_assignmentsQuery } from 'redux/api/assignmentsApi'
import { Add } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { IGroupCourse } from 'types'
import { removeEmpty } from 'utils/helpers'

interface IProps {
  groupCourse: IGroupCourse
  viewOnly: boolean
  tabText?: string
  tabKey?: string
}

const GroupCourseAssignments: FC<IProps> = ({ groupCourse, viewOnly }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const navigate = useNavigate()

  const filters = {
    group: groupCourse.group?.id,
    course: groupCourse.course?.id,
  }

  return (
    <>
      <Grid container spacing={4} sx={{ marginTop: '-1rem' }}>
        <Grid item xs={6}>
          <PageHeading title={t('common.assignments')} /> 
        </Grid>
        <Grid item xs={6}>

          <Box
              className="transparent-background"
              sx={{
                display: 'flex',
                justifyContent: 'right',
                alignItems: 'center',
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
              }}
            >
            <Tooltip title={`${t('common.add')}`} arrow placement='top'>
              <Button
                variant='contained'
                color='success'
                aria-haspopup='true'
                onClick={() => navigate(`/assignments/add?group_course=${groupCourse.id}`)}
                disableElevation
                sx={{
                  '&:hover': { background: theme.palette.success.main, border: 'none', '& svg': { color: '#000' } },
                  height: '2.75rem',
                  padding: '5',
                  minWidth: 'auto',
                  marginRight: '0.2rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: 'none',
                }}
              >
                <Add
                  sx={{ fontSize: '2rem', lineHeight: '1' }}
                />
                <span style={{ marginLeft: '0.5rem', display: 'inline-block' }}>{`${t(
                            'common.add',
                          )}`}</span>

              </Button>
            </Tooltip>
          </Box>
        </Grid>
      </Grid>

      <MainTable
        useTableModel={useTableModel}
        getTableData={useGET_assignmentsQuery}
        filters={removeEmpty(filters)}
        header={null}
      />
    </>
  )
}
export default GroupCourseAssignments